<template>
  <div class="menu-wrapper">
    <a-dropdown
      :getPopupContainer="node => node.parentNode"
      placement="bottomCenter"
      overlayClassName="menu-sub-item-card"
    >
      <div class="menu-item">
        <span>{{ $t('header.generalSecurityCertification') }}</span>
        <img class="arrow-icon" src="/image/header/arrow.svg">
      </div>
      <template #overlay>
        <div :class="{ 'rtl--container': isArSite }">
          <!-- <div v-at-navigation="'main_menu::overview'" class="menu-sub-item" @click="toPage('/general-security-certification/overview')"> -->
          <div v-at-navigation="'main_menu::overview'" class="menu-sub-item" @click="toCertificationPage(CERTIFICATION_TYPE.gsc, 'overview')">
            <span>{{ $t('header.Overview') }}</span>
            <img class="overlay-menu-arrow-icon" src="@/assets/icon/right-red.svg">
          </div>
          <div class="menu-sub-item-desc">
            {{ $t('global.GSCOveriewDesc') }}
          </div>
          <div v-at-navigation="'main_menu::online-video-courses'" class="menu-sub-item" style="margin-bottom:20px;" @click="toCertificationPage(CERTIFICATION_TYPE.gsc, 'online-video-courses')">
            <span>{{ $t('header.onlineVideoCourses') }}</span>
          </div>
          <div v-at-navigation="'main_menu::classroom'" class="menu-sub-item" @click="toCertificationPage(CERTIFICATION_TYPE.gsc, 'classroom')">
            <span>{{ $t('header.instructor-ledTraining') }}</span>
          </div>
        </div>
      </template>
    </a-dropdown>
    <div class="menu-interval" />
    <a-dropdown
      :getPopupContainer="node => node.parentNode"
      placement="bottomCenter"
      overlayClassName="menu-sub-item-card"
    >
      <div class="menu-item">
        <span>{{ $t('header.hikSecurityCertification') }}</span>
        <img class="arrow-icon" src="/image/header/arrow.svg">
      </div>
      <template #overlay>
        <div :class="{ 'rtl--container': isArSite }">
          <div v-at-navigation="'main_menu::overview'" class="menu-sub-item" @click="toCertificationPage(CERTIFICATION_TYPE.hsc, 'overview')">
            <span>{{ $t('header.Overview') }}</span>
            <img class="overlay-menu-arrow-icon" src="@/assets/icon/right-red.svg">
          </div>
          <div class="menu-sub-item-desc">
            {{ $t('global.HSCOveriewDesc') }}
          </div>
          <div v-at-navigation="'main_menu::online-video-courses'" class="menu-sub-item" style="margin-bottom:20px;" @click="toCertificationPage(CERTIFICATION_TYPE.hsc, 'online-video-courses')">
            <span>{{ $t('header.onlineVideoCourses') }}</span>
          </div>
          <div v-at-navigation="'main_menu::classroom'" class="menu-sub-item" @click="toCertificationPage(CERTIFICATION_TYPE.hsc, 'classroom')">
            <span>{{ $t('header.instructor-ledTraining') }}</span>
          </div>
        </div>
      </template>
    </a-dropdown>
    <div class="menu-interval" />
    <div v-at-navigation="'main_menu::my-learning'" class="menu-item my-learning" @click="onMyLearning">
      <span>{{ $t('header.myLearning') }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { Dropdown } from 'ant-design-vue'
import { useStoreHooks } from '@/store/hook'
import { useHeaderHook } from '@/utils/moduleHooks/global'
import { CERTIFICATION_TYPE } from '@/utils/config'
import { login } from '@/utils'

export default defineComponent({
  components: {
    'a-dropdown': Dropdown
  },
  setup () {
    const { getters, state: _state } = useStoreHooks()
    const {
      toPage,
      toCertificationPage
    } = useHeaderHook()
    const onMyLearning = () => {
      if (!getters['global/isLogin']) {
        login(`/${window.prefix}/my-learning`)
      } else {
        toPage('/my-learning')
      }
    }
    const isArSite = computed(() => _state.global.isArSite)
    return {
      isArSite,
      CERTIFICATION_TYPE,
      toCertificationPage,
      onMyLearning
    }
  }
})
</script>
<style lang="less" src="./menu.less"></style>
<style lang="less">
.menu-sub-item-card {
  width: 432px;
  background: #FFFFFF;
  box-shadow: 0px 50px 76px 0px rgba(11,35,48,0.22);
  padding: 30px 30px;
  .menu-sub-item-desc {
    font-size: 14px;
    color: #666666;
    line-height: 22px;
    font-weight: 400;
    margin: 20px 0 20px 0;
  }

  .menu-sub-item {
    font-size: 16px;
    color: #333333;
    font-weight: 600;
    height: 22px;
    cursor: pointer;
    display: flex;
    align-items: center;
    img {
      margin-left: 6px;
    }
  }
  .menu-sub-item span:hover{
    color: #D7150E;
  }
}
</style>
